import { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Api from "../../../../api/Api";

const ModalCreateUser = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // const [firstPasswordRule, setFirstPasswordRule]=useState("black");
    // const [secondPasswordRule, setSecondPasswordRule]=useState("black");
    // const [thirdPasswordRule, setThirdPasswordRule]=useState("black");
    // const [fourthPasswordRule, setFourthPasswordRule]=useState("black");
    // const [fithPasswordRule, setFithPasswordRule]=useState("black");

    const role_full={
        "Auditor":"Аудитор",
        "Admin":"Администратор",
        "Moderator":"Модератор",
        "User":"Пользователь",
        "Admin-RO":"Администратор наблюдатель"
    }

    // const checkUpperScale = (pwd) => /[A-ZА-ЯЁ]/.test(pwd);
    // const checkLowerScale = (pwd) => /[a-zа-яё]/.test(pwd);
    // const checkNumiric = (pwd) => /[0-9]/.test(pwd);
    // const checkSpecialSymbols = (pwd) => /[!@#$%^&*(),.?":{}|<>/]/.test(pwd);
    // const checkLength = (pwd) => pwd.length > 10;

    // const validation = (typeChecking, colorRebrush) => {
    //     if(!typeChecking){
    //         colorRebrush("red");
    //         return false;
    //     }
    //     colorRebrush("green");
    //     return true;
    // }

    // // Очищаем предупреждения перед проверкой
    // const validatePassword = (pwd) => {        
    //     const check_result_1=validation(checkLength(pwd),setFirstPasswordRule);
    //     const check_result_2=validation(checkLowerScale(pwd),setSecondPasswordRule);
    //     const check_result_3=validation(checkUpperScale(pwd),setThirdPasswordRule);
    //     const check_result_4=validation(checkNumiric(pwd),setFourthPasswordRule);
    //     const check_result_5=validation(checkSpecialSymbols(pwd),setFithPasswordRule);

    //     return (check_result_1 && check_result_2 && check_result_3 && check_result_4 && check_result_5);
    // };

    const send_api = async(data) =>{
        try {
            const response = await Api({
                method:"post",
                url:`/users/add`,
                headers:{},
                data:data
            })
            alert("пользователь создан")
            window.location.reload();
        } catch (error) {
            // alert("Ошибка при создании пользователя")
            alert(error);
        }
    }
    
    const handleSave = async(e) => {
        e.preventDefault();
        const data = {
            username: document.getElementById("username").value,
            email: document.getElementById("email").value,
            name: document.getElementById("name").value,
            surname: document.getElementById("surname").value,
            patronymic: document.getElementById("patronymic").value,
            role: document.getElementById("role").value,
            job_title: document.getElementById("job_title").value,
            // password: document.getElementById("password").value
        }
        // if (validatePassword(document.getElementById("password").value)){
        //     await send_api(data)
        // }
        await send_api(data)
    }


    return(
        <>
        <Button variant="primary" onClick={handleShow}>
            Создать
        </Button>

        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
            <Modal.Title>Создать пользователя</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSave}>
                    <Row>
                        <Col md={6}>
                            <Form.Control 
                            id="username"
                            className="mb-2"
                            placeholder="Username/логин..."
                            required/>
                            <Form.Control 
                            id="surname"
                            className="mb-2"
                            placeholder="Фамилия..." 
                            required/>
                            <Form.Control 
                            id="name"
                            className="mb-2"
                            placeholder="Имя..." 
                            required/>
                            <Form.Control 
                            id="patronymic"
                            className="mb-2"
                            placeholder="Отчество..." 
                            required/>
                        </Col>
                        <Col md={6}>
                            <Form.Control 
                            id="email"
                            className="mb-2"
                            type="email" 
                            placeholder="Email..."
                            required/>
                            <Form.Select id="role" className="mb-2">
                                {Object.keys(role_full).map((element)=>(<option key={element} value={element}>{role_full[element]}</option>))}
                            </Form.Select>
                            <Form.Control
                            id="job_title" 
                            className="mb-2"
                            placeholder="Должность..."/>
                            {/* <Form.Control 
                            id="password" 
                            className="mb-2" 
                            placeholder="Пароль..." 
                            required/> */}
                        </Col>
                    </Row>
                    {/* <div className="text-mutted">
                        <div>Требования к паролю:</div>
                        <ul>
                            <li style={{color:firstPasswordRule}}>От 10 символов;</li>
                            <li style={{color:secondPasswordRule}}>Минимум одна прописная буква(abcdef...z);</li>
                            <li style={{color:thirdPasswordRule}}>Минимум одна заглавная буква(ABCDEF...Z);</li>
                            <li style={{color:fourthPasswordRule}}>Минимум одна цифра(12345...0);</li>
                            <li style={{color:fithPasswordRule}}>Минимум один спецсимвол(!$@%^.../);</li>
                        </ul>
                    </div> */}
                    <div className="mt-1" >
                        <Button variant="primary" className="free-btn mt-1" type="submit">
                            Создать
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
        </>
    )   
}

export default ModalCreateUser;